import type { NavItem } from '../types/content';

export const primaryNav: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Our Team', to: '/our-team' },
  { label: 'Our Services', to: '/services' },
  { label: 'For Employers', to: '/employers' },
  { label: 'For Candidates', to: '/candidates' },
  { label: 'Leadership & Board Search', to: '/leadership-board-search' },
  { label: 'Contact', to: '/contact' },
];

export const legalNav: NavItem[] = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms of Use', to: '/terms-of-use' },
];

export const discussSearchHref = '/employers#employer-inquiry';
